import React, { useEffect, useState } from "react";
import { Row, Col, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { Radio } from "antd";
import { Button, Form, Input, message, Space } from "antd";
import useGetApi from "../../services/useGetApi";
import { useParams } from "react-router-dom";
import usePost from "../../services/usePost";
// import ThumbnailUploader from "../ThumbnailUploader";
// import FileUploader from "../../../components/fileUploader/FileUploader";

const AddLesson = ({ addLessonBtn, setAddLessonBtn,loadSections }) => {
  const [form] = Form.useForm();
  const { id } = useParams(); // Extract course ID from the URL
  const [sectionSelect, setSectionSelect] = useState([]);
  const [nextBtn, setNextBtn] = useState(true);
  const [addLesson, setAddLesson] = useState({
    attachment: "",
    attachmentType: "", // Default attachment type
    audioUrl: "",
    caption: "",
    cloudVideoId: 3,
    courseId: id,
    dateAdded: new Date().toISOString(),
    duration: "",
    durationForMobileApplication: "",
    isFree: 0,
    lastModified: new Date().toISOString(),
    lessonType: "YouTube Video", 
    order: 0,
    quizAttempt: 0,
    sectionId: '',
    summary: "",
    title: "",
    videoType: "",
    videoTypeForMobileApplication: "",
    videoUrl: "",
    videoUrlForMobileApplication: ""
  });

  const [isPostLoading, postError, postData] = usePost();
  const [isLoading, courseError, coursesInfo, getCourseData] = useGetApi(`course/get?id=${id}`, [], true);

  const [
    sectionsIsLoading,
    sectionsError,
    sections,
    getSections,
  ] = useGetApi(`course/details/${id}`, [], true);

  useEffect(() => {
    getSections(`course/details/${id}`); 
  }, [id]);

  useEffect(() => {
   getCourseData(`course/get?id=${id}`); 
  }, [id]);

  useEffect(() => {
    if (sections) {
      const formattedOptions = sections?.sections?.map((section) => ({
        value: section.id,
        label: section.title,
      }));
      setSectionSelect(formattedOptions); 
    }
  }, [sections]);

  const handleImageUpload = (filePath) => {
    setAddLesson({ ...addLesson, videoUrl: filePath })

  };


  const onFinish = async () => {
    const response = await postData("lessons", addLesson, true);
    if (response) {
      // message.success("Lesson added successfully!");
      loadSections(`course/details/${id}`); 
      setAddLessonBtn(false)
    } else {
      message.error("Failed to add lesson.");
    }
  };

  const onFinishFailed = () => {
    message.error("Submit failed!");
  };




  // useEffect(() =>{
  //   console.log(addLesson,'fjkjfjkgjfgk')
  // },[addLesson])

  
  return (
    <div>
      {addLessonBtn && (
        <div className="popup-overlay" style={{marginTop:'20px'}}>
          <div className="addlesson-popup-container p-20">
            <Row gutter={16}>
              <Col span={12}>
                <h5>Add Lesson</h5>
              </Col>
              <Col span={12}>
                <button
                  className="close-btn"
                  onClick={() => setAddLessonBtn(false)}
                >
                  <CloseOutlined />
                </button>
              </Col>
            </Row>

            <Row className="popup_horizontal_line"></Row>

            {nextBtn ? (
              <Form
                form={form}
                layout="vertical"
                initialValues={{
                  lessonType: "YouTube Video",
                  attachmentType: "pdf", // Default attachment type
                }}
              >
                <Row className="update_lesson_header">
                  <Col>
                    <span>Course: </span>
                    <strong>{coursesInfo?.title}</strong>
                  </Col>
                </Row>

                <h6>Select Lesson Type</h6>

                <Form.Item
                  name="lessonType"
                  label="Lesson Type"
                  rules={[{ required: true, message: "Please select a lesson type!" }]}
                  style={{ height: "420px" }}
                >
                  <Radio.Group
                    style={{ display: "flex", flexDirection: "column", gap: "15px" }}
                    onChange={(e) => setAddLesson({ ...addLesson, lessonType: e.target.value })}
                  >
                    <Radio value="YouTube Video">YouTube Video</Radio>
                    <Radio value="Vimeo Video">Vimeo Video</Radio>
                    <Radio value="Video file">Video file</Radio>
                    <Radio value="Audio file">Audio file</Radio>
                    <Radio value="Video url [ .mp4 ]">Video url [ .mp4 ]</Radio>
                    <Radio value="Wasabi storage video">Wasabi storage video</Radio>
                    <Radio value="Google drive video">Google drive video</Radio>
                    <Radio value="Document file">Document file</Radio>
                    <Radio value="Text">Text</Radio>
                    <Radio value="Image file">Image file</Radio>
                    <Radio value="Iframe embed">Iframe embed</Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item>
                  <button type="button" onClick={() => setNextBtn(false)} className="add_lesson_next_btn">
                    Next
                  </button>
                </Form.Item>
              </Form>
            ) : (
              <div>
                <Row className="update_lesson_header">
                  Lesson Type: <strong>{addLesson.lessonType}</strong>
                </Row>

                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    label="Title"
                    name="title"
                    rules={[{ required: true, message: "Please input the lesson title!" }]}
                  >
                    <Input
                      value={addLesson.title}
                      onChange={(e) => setAddLesson({ ...addLesson, title: e.target.value })}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Section"
                    name="sectionId"
                    rules={[{ required: true, message: "Please select a section!" }]}
                  >
                    <Select
                      value={addLesson.sectionId}
                      onChange={(value) => setAddLesson({ ...addLesson, sectionId: value })}
                      options={sectionSelect}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Video URL"
                    name="videoUrl"
                    rules={[{ required: true, message: "Please input the video URL!" }]}
                  >
                    {
                        (addLesson?.lessonType === "YouTube Video" || addLesson?.lessonType === "Vimeo Video" || addLesson?.lessonType === "Iframe embed") 
                        ? <Input
                            value={addLesson.videoUrl}
                            onChange={(e) => setAddLesson({ ...addLesson, videoUrl: e.target.value })}
                          />
                        : 
                         <div>
                           {/* <FileUploader
                              onImageUpload={handleImageUpload}
                              subdir="lessons"
                              fileName={addLesson.videoUrl}
                           /> */}
                         </div>
                      
                    }
                  </Form.Item>
                  
                  <Form.Item
                    label="Duration"
                    name="duration"
                    rules={[{ required: true, message: "Please input the video duration!" }]}
                   
                  >
                    <Input
                      value={addLesson.duration}
                      onChange={(e) => setAddLesson({ ...addLesson, duration: e.target.value })}
                    />
                  </Form.Item>

                  <p>Do you want to keep it free as a preview lesson?</p>
                  <div>
                    <input
                      type="checkbox"
                      checked={addLesson.isFree === 1}
                      onChange={() => setAddLesson({ ...addLesson, isFree: addLesson.isFree === 1 ? 0 : 1 })}
                    /> 
                      Mark as free lesson
                  </div>

                  <Form.Item>
                    <Space>
                      <Row className="submit_btn_div">
                        <button className="popup_update_lesson_btn w-100"
                         htmlType="submit"
                        >
                          Add Lesson
                        </button>
                      </Row>
                    </Space>
                  </Form.Item>
                </Form>
              </div>
            )}

            <Row className="back_btn_div">
              <button
                className="add-lesson-popup_back_btn"
                type="button"
                onClick={() => setAddLessonBtn(false)}
              >
                Back
              </button>
            </Row>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddLesson;
